'use client'

import { Alert } from 'antd'
import dayjs from 'dayjs'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

type OfflineSnapshotBannerProps = {
  savedAt: number
}

const OfflineSnapshotBanner: FC<OfflineSnapshotBannerProps> = ({ savedAt }) => {
  const { t } = useTranslation()

  return (
    <Alert
      type="warning"
      showIcon
      message={t('booking.offline_snapshot_banner', {
        time: dayjs(savedAt).format('DD/MM/YYYY HH:mm'),
      })}
      style={{ marginBottom: '1rem' }}
    />
  )
}

export default OfflineSnapshotBanner
